import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/reducers';
import { closeModal } from 'src/reducers/modal.reducer';
import ModalBackdrop from './modal-backdrop';
import ModalBody from './modal-body';
import ModalContent from './modal-content';
import ModalFooter from './modal-footer';
import ModalHeader from './modal-header';
import styles from './modal.module.scss';

const Modal = () => {
  const dispatch = useAppDispatch();
  const modalState = useAppSelector(state => state.modal);

  const wrapper = cx(styles.modalWrapper, {
    [styles.open]: modalState.open,
  });

  const handleKey = useCallback(
    e => {
      e.keyCode === 27 && dispatch(closeModal());
    },
    [dispatch]
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, [handleKey]);

  useEffect(() => {
    if (!modalState.open) {
      document.body.removeAttribute('style');
    } else {
      document.body.style.overflow = 'hidden';
    }
  }, [modalState.open]);

  return (
    <div className={wrapper}>
      <Modal.Backdrop />
      <Modal.Content>{modalState.children}</Modal.Content>
    </div>
  );
};

Modal.Content = ModalContent;
Modal.Backdrop = ModalBackdrop;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
